import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import style from "./style.css";

export default class RadioButton extends Component {
  render() {
    const { rootClassname, isDisabled, onClick, label, value, checked, name, id } = this.props;
    const finalRootClass = classnames(style.root, rootClassname);
    return (
      <div className={finalRootClass} onClick={onClick.bind(this)}>
        <input name={name} type="radio" value={value} checked={checked} {... id !== "" ? {id: id} : {}} {... isDisabled === true && isDisabled !== undefined ? {disabled: isDisabled} : {}} />
        <label {... id !== "" ? {htmlFor: id} : {}}>{label}</label>
      </div>
    );
  }
}

RadioButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  label: PropTypes.object.isRequired,
  rootClassname: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.string,
};

RadioButton.defaultProps = {
  name: "radioComponent",
  id: "",
};



// WEBPACK FOOTER //
// ./src/components/RadioButton/index.js